import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { ServerSentEvents } from "./ServerSentEvents";
import {
  NotificationBase,
  NotificationTempMapping,
} from "../types/notification.types";
import { tempMapping } from "./notification.service";
import { notificationMessagesCache } from "./NotificationMessagesCache";

const SSE_BASE_URL = `${CORE_SERVICE_URL}/notifications/sse`;

export class NotificationMessages {
  private sseEvents: ServerSentEvents | null = null;

  constructor(
    private storeId: string,
    private uid: string,
    private bearerToken: () => Promise<string | null>
  ) {}

  // Get createdAt from newest notification message.
  private getNewestCreatedAt() {
    const cachedMessages = notificationMessagesCache.getMessagesForStoreAndUid(
      this.storeId,
      this.uid
    );
    if (cachedMessages && cachedMessages.length) {
      const firstMessage = cachedMessages.at(0);
      return firstMessage!.createdAt;
    }
    return "";
  }

  // Open server sent event connection
  async open() {
    try {
      const headers = async (): Promise<HeadersInit> => ({
        Authorization: `Bearer ${(await this.bearerToken()) ?? ""}`,
        "Content-Type": "text/event-stream",
      });
      const url = `${SSE_BASE_URL}/stores/${encodeURIComponent(this.storeId)}/users/${encodeURIComponent(this.uid)}/messages`;
      this.sseEvents = new ServerSentEvents(url, headers, [
        `createdAt=${encodeURIComponent(this.getNewestCreatedAt())}`,
      ]);
      this.sseEvents.onmessage = ({ event, data }) => {
        try {
          if (event && event.includes("max-notifications-count:")) {
            const maxCount = parseInt((event.split(":")[1] ?? "").trim(), 10);
            if (!isNaN(maxCount)) {
              notificationMessagesCache.setMaxCount(
                this.storeId,
                this.uid,
                maxCount
              );
            }
          }

          if (data) {
            const json = JSON.parse(data) as NotificationTempMapping[];
            const messages = json.map(tempMapping) as NotificationBase[];
            notificationMessagesCache.update(this.storeId, this.uid, messages);
            this.sseEvents!.setQueryParams([
              `createdAt=${encodeURIComponent(this.getNewestCreatedAt())}`,
            ]);
          }
        } catch (error) {
          console.error(
            `NotificationMessages: onmessage failed ${(error as Error).message}`
          );
        }
      };
    } catch (error) {
      console.error(
        `NotificationMessages: open failed ${(error as Error).message}`
      );
    }
  }

  // Close connection
  close() {
    if (this.sseEvents) {
      this.sseEvents.close();
    }
  }
}
